import React from "react";

import BaseOverlay from "./base.jsx";
import { FlatButton, TextField, Checkbox } from "material-ui";
import DatePicker from "../datepicker.jsx";
import moment from "moment";

class GiftDetailsOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dirty: false,
      updatedData: {},
      showScheduledSendInput: false
    };

    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this);
    this._onUpdateData = this._onUpdateData.bind(this);
    this._onUpdateScheduleDate = this._onUpdateScheduleDate.bind(this);
    this._toggleScheduledSendInput = this._toggleScheduledSendInput.bind(this);
  }

  componentWillMount() {
    const giftCard = this.props.orderData.subitems[this.props.giftCardIndex];

    const today = moment();
    const giftScheduledSend = moment(giftCard.giftScheduledSend);

    const isGiftScheduledSendToday = today.isSame(giftScheduledSend, "day");

    this.setState({
      updatedData: {
        recipientName: giftCard.recipientName,
        recipientEmail: giftCard.recipientEmail,
        giftMessage: giftCard.giftMessage,
        giftScheduledSend: isGiftScheduledSendToday
          ? undefined
          : giftScheduledSend.format("YYYY-MM-DD")
      },
      showScheduledSendInput: !isGiftScheduledSendToday
    });
  }

  cancel() {
    this.props.requestClose();
  }

  submit() {
    this.props.onSubmit(this.props.giftCardIndex, this.state.updatedData);
  }

  _onUpdateData(event) {
    this.setState({
      dirty: true,
      updatedData: {
        ...this.state.updatedData,
        [event.target.name]: event.target.value
      }
    });
  }

  _onUpdateScheduleDate(date) {
    this._onUpdateData({ target: { name: "giftScheduledSend", value: date } });
  }

  _toggleScheduledSendInput() {
    this.setState({
      showScheduledSendInput: !this.state.showScheduledSendInput
    });
  }

  render() {
    return (
      <BaseOverlay
        title={`Gift Card ${this.props.giftCardIndex + 1} Details`}
        useMuiDefaultStyle={true}
        openImmediately={true}
        actions={[
          <FlatButton label={"Cancel"} onTouchTap={this.cancel} />,
          <FlatButton
            disabled={!this.state.dirty}
            primary={true}
            label={"Submit"}
            onTouchTap={this.submit}
          />
        ]}
        open={true}
        modal={true}
        onRequestClose={this.cancel}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column"
          }}
        >
          <TextField
            floatingLabelText="Recipient Name"
            value={this.state.updatedData.recipientName}
            name="recipientName"
            onChange={this._onUpdateData}
          />
          <TextField
            floatingLabelText="Recipient Email"
            value={this.state.updatedData.recipientEmail}
            name="recipientEmail"
            onChange={this._onUpdateData}
          />
          <TextField
            floatingLabelText="Gift Message"
            value={this.state.updatedData.giftMessage}
            name="giftMessage"
            onChange={this._onUpdateData}
          />
          <Checkbox
            label="Schedule Gift Card Notification to Different Date"
            checked={this.state.showScheduledSendInput}
            onCheck={this._toggleScheduledSendInput}
            style={{ marginTop: 36 }}
          />
          {this.state.showScheduledSendInput && (
            <DatePicker
              label="Scheduled Send Date"
              value={this.state.updatedData.giftScheduledSend}
              minDate={new Date()}
              onChange={this._onUpdateScheduleDate}
              name="giftScheduledSend"
            />
          )}
        </div>
      </BaseOverlay>
    );
  }
}

export default GiftDetailsOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/gift-details-overlay.jsx